/**
 * PHARMAKON — Modal (design-system port)
 *
 * Wraps the design Modal from primitives.tsx and accepts the legacy
 * `isOpen` prop as an alias for `open`, so existing pages don't all break
 * in one go. The visual + behaviour is the design's exactly.
 */
import * as React from "react";
import {
  Modal as DesignModal,
  type ModalProps as DesignModalProps,
} from "./primitives";

export interface ModalProps
  extends Omit<DesignModalProps, "open" | "onClose" | "size"> {
  open?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
  size?: DesignModalProps["size"];
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({
  open,
  isOpen,
  onClose,
  ...rest
}) => (
  <DesignModal open={open ?? isOpen ?? false} onClose={onClose} {...rest} />
);

export default Modal;
